import { render, staticRenderFns } from "./RiskObjective.vue?vue&type=template&id=58395252&scoped=true&"
import script from "./RiskObjective.vue?vue&type=script&lang=js&"
export * from "./RiskObjective.vue?vue&type=script&lang=js&"
import style0 from "./RiskObjective.vue?vue&type=style&index=0&id=58395252&lang=scss&scoped=true&"
import style1 from "./RiskObjective.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58395252",
  null
  
)

export default component.exports